import { Component, OnInit } from '@angular/core';
import {ControlPosition, ZoomControlOptions, ZoomControlStyle} from '@agm/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
   mapStyle = [
      {
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#f0f0f0"
            }
         ]
      },
      {
         "elementType": "labels.icon",
         "stylers": [
            {
               "visibility": "off"
            }
         ]
      },
      {
         "elementType": "labels.text.fill",
         "stylers": [
            {
               "color": "#b9b9b9"
            }
         ]
      },
      {
         "elementType": "labels.text.stroke",
         "stylers": [
            {
               "color": "#f7f7f7"
            }
         ]
      },
      {
         "featureType": "administrative.land_parcel",
         "elementType": "labels.text.fill",
         "stylers": [
            {
               "color": "#bdbdbd"
            }
         ]
      },
      {
         "featureType": "poi",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#d7d7d7"
            }
         ]
      },
      {
         "featureType": "poi",
         "elementType": "labels.text.fill",
         "stylers": [
            {
               "color": "#757575"
            }
         ]
      },
      {
         "featureType": "poi.park",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#dcdcdc"
            }
         ]
      },
      {
         "featureType": "poi.park",
         "elementType": "labels.text.fill",
         "stylers": [
            {
               "color": "#9e9e9e"
            }
         ]
      },
      {
         "featureType": "road",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#ffffff"
            }
         ]
      },
      {
         "featureType": "road.arterial",
         "elementType": "labels.text.fill",
         "stylers": [
            {
               "color": "#757575"
            }
         ]
      },
      {
         "featureType": "road.highway",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#dadada"
            }
         ]
      },
      {
         "featureType": "road.highway",
         "elementType": "labels.text.fill",
         "stylers": [
            {
               "color": "#616161"
            }
         ]
      },
      {
         "featureType": "road.local",
         "elementType": "labels.text.fill",
         "stylers": [
            {
               "color": "#9e9e9e"
            }
         ]
      },
      {
         "featureType": "transit.line",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#e5e5e5"
            }
         ]
      },
      {
         "featureType": "transit.station",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#eeeeee"
            }
         ]
      },
      {
         "featureType": "water",
         "elementType": "geometry",
         "stylers": [
            {
               "color": "#c9c9c9"
            }
         ]
      },
      {
         "featureType": "water",
         "elementType": "labels.text.fill",
         "stylers": [
            {
               "color": "#9e9e9e"
            }
         ]
      }
   ];

   zoomControlOptions: ZoomControlOptions = {
      position: ControlPosition.RIGHT_TOP,
      style: ZoomControlStyle.SMALL
   };
   mapSettings = {
      lat: 37.776250,
      lng: -122.417061,
      zoom: 15,
      scrollWheel: false,
      streetViewControl: false,
      style: this.mapStyle,
      zoomControlOptions: this.zoomControlOptions
   };
  constructor() { }

  ngOnInit(): void {
  }

}
